var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTicketWin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20693_14558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4668 18.2781L11.6601 75.9548C12.2651 80.4648 15.2168 83.1598 19.9468 83.3798L73.5351 75.9365C78.5585 74.5248 82.2618 73.1498 82.4451 69.2631L83.8018 29.3881C83.9668 25.5198 80.2451 22.1831 75.5151 21.9631L10.3585 11.6048C5.62846 11.4031 1.6318 14.4098 1.4668 18.2781Z",
    fill: "url(#paint0_linear_20693_14558)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5084 55.8615L79.7501 46.8415C79.5668 46.9515 79.3835 47.0431 79.1818 47.1348C75.7718 48.5465 71.1884 45.3565 68.9701 40.0031C66.7518 34.6498 67.7234 29.1498 71.1334 27.7381C71.3351 27.6648 71.5368 27.5915 71.7384 27.5365L68.5301 19.7998L21.1201 39.4898L36.0801 75.5515L83.5084 55.8615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.36328 44.3301L8.10328 53.3501C8.28661 53.2401 8.46995 53.1484 8.67161 53.0568C12.0816 51.6451 16.6649 54.8351 18.8833 60.1884C21.1016 65.5418 20.1299 71.0418 16.7199 72.4535C16.5183 72.5268 16.3166 72.6001 16.1149 72.6551L19.3233 80.3918L35.4933 73.6818L20.5333 37.6201L4.36328 44.3301Z",
    fill: "#FF5AAD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3223 13.8438L75.4212 28.5036L73.9715 30.0749C71.9764 32.2373 71.3059 35.4307 72.4946 38.3067C73.6796 41.1737 76.4093 42.9451 79.3355 43.0478L81.477 43.1229L87.5798 57.7922L18.1995 86.5866L12.0722 71.8365L13.4374 70.2749C15.3058 68.1378 15.9049 65.0393 14.7534 62.2503C13.609 59.4781 10.9938 57.7161 8.15245 57.5233L6.08947 57.3833L-0.0361328 42.6375L69.3223 13.8438ZM8.68972 46.2425L10.7368 51.1704C15.1557 52.1491 19.0627 55.1958 20.9235 59.703C22.7782 64.1955 22.1942 69.113 19.7581 72.9383L21.8041 77.8634L78.8504 54.1878L76.8867 49.4675C72.3163 48.5852 68.245 45.5001 66.3256 40.8566C64.4087 36.2189 65.094 31.1621 67.6883 27.2943L65.7213 22.5662L8.68972 46.2425Z",
    fill: "url(#paint1_linear_20693_14558)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6223 62.026C32.4424 61.2698 34.531 62.1322 35.2872 63.9524L35.4224 64.2778C35.468 64.3876 35.5078 64.4984 35.5418 64.6098C35.5967 64.7125 35.6472 64.8188 35.6928 64.9286L35.9633 65.5794C36.0089 65.6892 36.0486 65.8 36.0826 65.9114C36.1376 66.0141 36.188 66.1205 36.2337 66.2303L36.5041 66.8811C36.5497 66.9909 36.5894 67.1017 36.6234 67.2131C36.6784 67.3158 36.7289 67.4221 36.7745 67.5319L37.0449 68.1828C37.0905 68.2926 37.1303 68.4034 37.1643 68.5148C37.2192 68.6175 37.2697 68.7238 37.3153 68.8336L37.4505 69.159C38.2068 70.9791 37.3443 73.0677 35.5242 73.824C33.7041 74.5802 31.6155 73.7178 30.8593 71.8976L30.7241 71.5722C30.6785 71.4624 30.6387 71.3516 30.6047 71.2402C30.5498 71.1375 30.4993 71.0312 30.4537 70.9214L30.1832 70.2706C30.1376 70.1607 30.0979 70.05 30.0639 69.9385C30.0089 69.8359 29.9585 69.7295 29.9128 69.6197L29.6424 68.9689C29.5968 68.8591 29.5571 68.7483 29.5231 68.6369C29.4681 68.5342 29.4176 68.4279 29.372 68.3181L29.1016 67.6672C29.056 67.5574 29.0162 67.4466 28.9822 67.3352C28.9273 67.2325 28.8768 67.1262 28.8312 67.0164L28.696 66.691C27.9397 64.8708 28.8022 62.7823 30.6223 62.026Z",
    fill: "url(#paint2_linear_20693_14558)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0573 51.026C27.8775 50.2698 29.966 51.1322 30.7223 52.9524L30.8575 53.2778C30.9031 53.3876 30.9428 53.4984 30.9768 53.6098C31.0318 53.7125 31.0823 53.8188 31.1279 53.9286L31.3983 54.5794C31.4439 54.6892 31.4837 54.8 31.5177 54.9114C31.5726 55.0141 31.6231 55.1205 31.6687 55.2303L31.9391 55.8811C31.9848 55.9909 32.0245 56.1017 32.0585 56.2131C32.1135 56.3158 32.1639 56.4221 32.2096 56.5319L32.48 57.1828C32.5256 57.2926 32.5653 57.4034 32.5993 57.5148C32.6543 57.6175 32.7048 57.7238 32.7504 57.8336L32.8856 58.159C33.6418 59.9791 32.7794 62.0677 30.9593 62.824C29.1392 63.5802 27.0506 62.7178 26.2943 60.8976L26.1591 60.5722C26.1135 60.4624 26.0738 60.3516 26.0398 60.2402C25.9848 60.1375 25.9343 60.0312 25.8887 59.9214L25.6183 59.2706C25.5727 59.1607 25.5329 59.05 25.499 58.9385C25.444 58.8359 25.3935 58.7295 25.3479 58.6197L25.0775 57.9689C25.0318 57.8591 24.9921 57.7483 24.9581 57.6369C24.9032 57.5342 24.8527 57.4279 24.8071 57.3181L24.5366 56.6672C24.491 56.5574 24.4513 56.4466 24.4173 56.3352C24.3623 56.2325 24.3118 56.1262 24.2662 56.0164L24.131 55.691C23.3748 53.8708 24.2372 51.7823 26.0573 51.026Z",
    fill: "url(#paint3_linear_20693_14558)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4965 40.0058C23.3176 39.2518 25.405 40.1168 26.159 41.9379L26.2942 42.2645C26.3399 42.3747 26.3796 42.4858 26.4135 42.5976C26.4685 42.7007 26.519 42.8074 26.5647 42.9176L26.8351 43.5707C26.8807 43.6809 26.9204 43.7921 26.9543 43.9039C27.0093 44.0069 27.0599 44.1136 27.1055 44.2238L27.3759 44.877C27.4215 44.9872 27.4612 45.0983 27.4951 45.2101C27.5502 45.3132 27.6007 45.4199 27.6463 45.5301L27.9167 46.1832C27.9624 46.2934 28.0021 46.4046 28.036 46.5164C28.091 46.6194 28.1415 46.7261 28.1872 46.8363L28.3224 47.1629C29.0763 48.984 28.2113 51.0715 26.3902 51.8254C24.5692 52.5794 22.4817 51.7144 21.7277 49.8933L21.5925 49.5668C21.5469 49.4566 21.5072 49.3454 21.4733 49.2336C21.4182 49.1305 21.3677 49.0238 21.3221 48.9136L21.0517 48.2605C21.006 48.1503 20.9663 48.0391 20.9324 47.9273C20.8774 47.8243 20.8269 47.7176 20.7813 47.6074L20.5108 46.9543C20.4652 46.8441 20.4255 46.7329 20.3916 46.6211C20.3366 46.518 20.286 46.4113 20.2404 46.3011L19.97 45.648C19.9244 45.5378 19.8847 45.4266 19.8508 45.3148C19.7957 45.2118 19.7452 45.1051 19.6996 44.9949L19.5644 44.6683C18.8104 42.8473 19.6754 40.7598 21.4965 40.0058Z",
    fill: "url(#paint4_linear_20693_14558)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7385 15.4915L37.2718 15.2899C37.1068 15.2715 36.9968 15.0882 37.0152 14.8682L37.5835 10.8899C37.6202 10.6332 37.8402 10.4865 38.0235 10.5965L39.3985 11.3482C39.5268 11.4215 39.5818 11.5682 39.5635 11.7332L39.0685 15.1799C39.0685 15.3632 38.9218 15.5099 38.7385 15.4915Z",
    fill: "#EE8322"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1999 21.9264L11.7333 21.7064C11.5683 21.688 11.4583 21.5047 11.4766 21.2847L12.0449 17.3064C12.0816 17.0497 12.3016 16.903 12.4849 17.013L13.8599 17.7647C13.9883 17.838 14.0433 17.9847 14.0249 18.1497L13.5666 21.5964C13.5299 21.798 13.3649 21.9447 13.1999 21.9264Z",
    fill: "#00D38D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1316 6.72812L16.6649 6.50812C16.4999 6.48978 16.3899 6.30645 16.4082 6.08645L16.9766 2.10812C17.0132 1.85145 17.2332 1.70478 17.4166 1.81478L18.7916 2.56645C18.9199 2.63978 18.9749 2.78645 18.9566 2.95145L18.4616 6.39812C18.4616 6.59978 18.2966 6.74645 18.1316 6.72812Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5634 28.8565L16.7934 27.5915C16.7017 27.4448 16.775 27.2431 16.9584 27.1331L20.405 25.0431C20.625 24.9148 20.8817 24.9881 20.9184 25.2081L21.2117 26.7481C21.23 26.8765 21.1567 27.0415 21.0284 27.1148L18.0584 28.9115C17.875 29.0398 17.655 29.0031 17.5634 28.8565Z",
    fill: "#D7D8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8136 34.1365L81.9136 33.1465C82.042 33.0365 82.262 33.0548 82.3903 33.2198L85.0853 36.1898C85.2503 36.3731 85.232 36.6482 85.0303 36.7215L83.582 37.3082C83.4536 37.3632 83.2887 37.3081 83.1787 37.1981L80.832 34.6315C80.7036 34.4665 80.6853 34.2465 80.8136 34.1365Z",
    fill: "#D7D8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8069 14.4281L22.2569 13.0715C22.1835 12.9065 22.2935 12.7231 22.4769 12.6498L26.1985 11.1281C26.4369 11.0365 26.6752 11.1465 26.6752 11.3665L26.7302 12.9431C26.7302 13.0898 26.6385 13.2181 26.4735 13.2731L23.2469 14.5931C23.0819 14.6481 22.8802 14.5748 22.8069 14.4281Z",
    fill: "#079D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.855 6.58159L31.68 5.35325C31.7717 5.20659 31.9917 5.18825 32.1567 5.29825L35.4934 7.55325C35.695 7.69992 35.7317 7.95659 35.5667 8.08492L34.2834 9.00159C34.1734 9.07492 34.0084 9.07492 33.8617 8.98325L30.9834 7.03992C30.8184 6.92992 30.745 6.72825 30.855 6.58159Z",
    fill: "#00D38D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2937 6.98463L76.4137 5.79296C76.3037 5.66463 76.3587 5.44463 76.5237 5.31629L79.7503 2.93296C79.952 2.78629 80.2087 2.84129 80.282 3.04296L80.722 4.54629C80.7587 4.67463 80.7037 4.83963 80.5753 4.93129L77.7887 7.00296C77.6053 7.1313 77.4037 7.13129 77.2937 6.98463Z",
    fill: "#00D38D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4735 13.7866L48.8952 11.6416C48.9502 11.3849 49.2252 11.2382 49.5185 11.2932L55.3852 12.4299C55.7519 12.5032 55.9535 12.8516 55.7885 13.1082L54.5785 15.1066C54.4686 15.2899 54.2302 15.3632 53.9919 15.3266L48.9135 14.3366C48.6385 14.2816 48.4369 14.0249 48.4735 13.7866Z",
    fill: "#079D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.017 27.1516C24.7503 26.9316 25.5387 27.3716 25.7403 28.1049C25.9603 28.8382 25.5203 29.6266 24.787 29.8282C24.0537 30.0482 23.2653 29.6082 23.0637 28.8749C22.8437 28.1416 23.2837 27.3532 24.017 27.1516Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7984 20.6429C33.0184 21.3763 32.5784 22.1646 31.8451 22.3663C31.1118 22.5863 30.3234 22.1463 30.1218 21.4129C29.9018 20.6796 30.3418 19.8913 31.0751 19.6896C31.8084 19.4696 32.5784 19.8913 32.7984 20.6429Z",
    fill: "#079D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.187 4.69313C29.407 5.42646 28.967 6.21479 28.2336 6.41646C27.5003 6.63646 26.712 6.19646 26.5103 5.46313C26.3086 4.72979 26.7303 3.94146 27.4636 3.73979C28.197 3.53813 28.967 3.95979 29.187 4.69313Z",
    fill: "#ACACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3036 34.6315L10.6702 33.2015C10.7069 33.0365 10.9086 32.9449 11.1102 32.9999L15.0152 33.9899C15.2536 34.0449 15.3819 34.2832 15.2719 34.4665L14.3919 35.7682C14.3186 35.8782 14.1536 35.9332 13.9886 35.8965L10.6152 35.0532C10.3952 34.9799 10.2669 34.7965 10.3036 34.6315Z",
    fill: "#D7D8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.50344 27.9216L0.678436 26.7116C0.58677 26.565 0.64177 26.3633 0.80677 26.2533L4.1251 23.98C4.32677 23.8333 4.60177 23.9066 4.63844 24.1083L5.02344 25.63C5.0601 25.7583 4.98677 25.9233 4.85844 26.015L1.9801 27.9766C1.8151 28.0683 1.5951 28.05 1.50344 27.9216Z",
    fill: "#00D38D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.59159 9.03822C5.77492 9.78989 5.31659 10.5416 4.56492 10.7249C3.81326 10.9082 3.06159 10.4499 2.87826 9.69822C2.69492 8.94656 3.15326 8.19489 3.90492 8.01156C4.65659 7.82822 5.40826 8.28656 5.59159 9.03822Z",
    fill: "#079D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2666 18.5163L75.735 17.1413C75.68 16.9763 75.7716 16.793 75.9733 16.7197L79.7316 15.2713C79.97 15.1797 80.2083 15.308 80.2083 15.5097L80.2266 17.0863C80.2266 17.233 80.1166 17.3613 79.97 17.4163L76.725 18.663C76.5233 18.7547 76.3216 18.6813 76.2666 18.5163Z",
    fill: "#EE8322"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6219 4.96828L59.0703 4.56495C59.2353 4.50995 59.4369 4.63828 59.5103 4.85828L60.8853 8.83662C60.9769 9.09328 60.8303 9.31328 60.6103 9.29495L58.9786 9.16662C58.8319 9.14828 58.7036 9.03828 58.6486 8.87328L57.4569 5.42662C57.3653 5.22495 57.4386 5.02328 57.6219 4.96828Z",
    fill: "#EE8322"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.232 22.4031L40.7553 21.0098C40.7003 20.8448 40.8103 20.6615 41.012 20.5881L44.8253 19.2865C45.0637 19.2131 45.302 19.3415 45.2837 19.5431L45.247 21.1198C45.247 21.2665 45.137 21.3948 44.972 21.4498L41.672 22.5681C41.4887 22.6598 41.287 22.5681 41.232 22.4031Z",
    fill: "#00D38D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2536 7.73641L71.7202 7.91974C71.8852 7.93807 72.0136 8.12141 71.9769 8.32307L71.4819 12.3197C71.4452 12.5764 71.2252 12.7231 71.0419 12.6314L69.6486 11.9164C69.5202 11.8614 69.4469 11.6964 69.4836 11.5314L69.9236 8.08474C69.9236 7.86474 70.0886 7.71807 70.2536 7.73641Z",
    fill: "#00D38D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.955 4.76668L45.0634 4.16168C45.3017 4.08834 45.5767 4.27168 45.65 4.56501L47.3 10.3033C47.41 10.67 47.19 11 46.8784 10.9817L44.55 10.8167C44.3484 10.7983 44.165 10.6333 44.0917 10.395L42.6617 5.42668C42.5884 5.13334 42.7167 4.84001 42.955 4.76668Z",
    fill: "#EE8322"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.322 36.3364L75.0203 35.6397C74.8737 35.5664 74.8187 35.3464 74.9287 35.1631L76.8353 31.6247C76.9453 31.4047 77.2203 31.3497 77.3487 31.4964L78.3937 32.6697C78.4853 32.7797 78.5037 32.9447 78.412 33.0914L76.762 36.1531C76.6703 36.3364 76.4687 36.4097 76.322 36.3364Z",
    fill: "#079D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.542 83.875L68.4753 64.625L72.692 74.8917L21.542 83.875Z",
    fill: "url(#paint5_linear_20693_14558)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5725 58.845L48.9928 59.0631L48.0105 36.3337L51.5639 36.1288L52.5725 58.845ZM43.4367 52.0724C40.5178 53.5395 37.0673 52.6386 35.468 49.4567C34.0273 46.5903 34.9677 43.1529 38.1497 41.5536C41.0949 40.0732 44.5321 40.9479 46.1183 44.1035C47.5722 46.9962 46.6449 50.4598 43.4367 52.0724ZM42.0884 49.3243C43.4558 48.637 43.7816 47.0568 43.0942 45.6893C42.3408 44.1904 40.8393 43.6934 39.577 44.3279C38.2359 45.002 37.8838 46.5953 38.5712 47.9628C39.3114 49.4354 40.8524 49.9455 42.0884 49.3243ZM62.2354 53.4281C59.3165 54.8952 55.866 53.9943 54.2799 50.8386C52.826 47.946 53.7664 44.5086 56.9484 42.9093C59.8936 41.4289 63.3441 42.3299 64.9302 45.4855C66.3841 48.3782 65.4437 51.8155 62.2354 53.4281ZM60.8871 50.68C62.2545 49.9927 62.5803 48.4125 61.8929 47.045C61.1528 45.5724 59.6512 45.0754 58.389 45.7099C57.0215 46.3972 56.6826 47.951 57.3699 49.3185C58.1101 50.7911 59.6248 51.3144 60.8871 50.68Z",
    fill: "#FF5AAD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20693_14558",
    x1: 2.35826,
    y1: 83.1839,
    x2: 83.3496,
    y2: 2.19254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97903"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0739316,
    stopColor: "#EC8709"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2075,
    stopColor: "#EF9910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3662,
    stopColor: "#F2A616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5723,
    stopColor: "#F4AE19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4B01A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20693_14558",
    x1: 10.0465,
    y1: 64.206,
    x2: 77.4696,
    y2: 36.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC41D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0770749,
    stopColor: "#A641D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4555,
    stopColor: "#8E40B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7765,
    stopColor: "#7E3F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793F98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20693_14558",
    x1: 30.8161,
    y1: 68.8653,
    x2: 35.3208,
    y2: 66.9958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC41D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0770749,
    stopColor: "#A641D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4555,
    stopColor: "#8E40B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7765,
    stopColor: "#7E3F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793F98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_20693_14558",
    x1: 26.2491,
    y1: 57.8606,
    x2: 30.7538,
    y2: 55.9911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC41D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0770749,
    stopColor: "#A641D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4555,
    stopColor: "#8E40B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7765,
    stopColor: "#7E3F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793F98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_20693_14558",
    x1: 21.6822,
    y1: 46.8557,
    x2: 26.1869,
    y2: 44.9862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC41D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0770749,
    stopColor: "#A641D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4555,
    stopColor: "#8E40B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7765,
    stopColor: "#7E3F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793F98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_20693_14558",
    x1: 21.542,
    y1: 74.25,
    x2: 72.692,
    y2: 74.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF1E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20693_14558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTicketWin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ticket-win.d64b8847d650bdd262238770e0b35e1e.svg";